module.exports = __webpack_public_path__ + "img/previous.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/assets/img/previous.png
// module id = 372
// module chunks = 0